/**
 * Abas da página de Despesas do Dia a Dia (chamado 3798): Todas / Excedidas /
 * Sem lançamento. Excedida é a despesa cujo realizado passou do planejado — o
 * mesmo critério do destaque vermelho do card.
 */
export type DailyExpenseTab = 'all' | 'exceeded' | 'unlaunched';

type NumberLike = number | string | null | undefined;

interface DailyExpenseTotals {
  planned_total: NumberLike;
  realized_total: NumberLike;
  realized_count: NumberLike;
}

const numero = (valor: NumberLike): number => Number(valor || 0);

export const isDailyExpenseExceeded = (expense: DailyExpenseTotals): boolean =>
  numero(expense.realized_total) > numero(expense.planned_total);

export const hasNoDailyExpenseLaunch = (expense: DailyExpenseTotals): boolean =>
  numero(expense.realized_count) === 0;

const NA_ABA: Record<DailyExpenseTab, (expense: DailyExpenseTotals) => boolean> = {
  all: () => true,
  exceeded: isDailyExpenseExceeded,
  unlaunched: hasNoDailyExpenseLaunch,
};

export const filterDailyExpensesByTab = <T extends DailyExpenseTotals>(
  expenses: T[],
  tab: DailyExpenseTab,
): T[] => expenses.filter(NA_ABA[tab]);

/** Contagem de cada aba; sem a lista ainda, nenhuma contagem (nada de um "0" enganoso). */
export const dailyExpenseTabCounts = (
  expenses: DailyExpenseTotals[] | undefined,
): Record<DailyExpenseTab, number | undefined> => ({
  all: expenses?.length,
  exceeded: expenses ? filterDailyExpensesByTab(expenses, 'exceeded').length : undefined,
  unlaunched: expenses ? filterDailyExpensesByTab(expenses, 'unlaunched').length : undefined,
});
